import React from 'react'
import { Outlet } from 'react-router-dom'

const AssetProfile = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AssetProfile
